import type { TOC } from '@ember/component/template-only';
import { styleEntry } from '@mylighthouse/prism-ember';

interface HotelMarketInsightChartsLegendLegendItemSignature {
  Args: {
    additionalValue: unknown;
    color: unknown;
    name: unknown;
    value: unknown;
  };
}

const HotelMarketInsightChartsLegendLegendItem = <template>
  {{! @glint-nocheck: not typesafe yet }}
  <div
    class="item chart-legend__item chart-legend__item--in-column-layout flex flex-row justify-between"
  >
    <div class="flex flex-row items-center">
      {{#if @color}}
        <span
          class="chart-legend__icon chart-legend__icon--no-top-margin"
          style={{styleEntry "background-color" @color}}
        ></span>
      {{/if}}
      <p class="text-200--regular {{if @color 'ml-100'}}">
        {{@name}}
      </p>
    </div>

    <div>
      <p class="text-200--regular">
        {{@value}}

        {{#if @additionalValue}}
          <span class="text-200--regular">({{@additionalValue}})</span>
        {{/if}}
      </p>
    </div>
  </div>
</template> satisfies TOC<HotelMarketInsightChartsLegendLegendItemSignature>;

export default HotelMarketInsightChartsLegendLegendItem;
